import { Route, Routes } from "react-router-dom";
import Contatos from "./pages/contato";
import Dashboard from "./pages";
import PaginaNaoEncontrada from "./pages/404";
import Casa from "./pages/casa";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/coisas-para-casa" element={<Casa />} />
      {/* <Route path="/coisas-para-bebe" element={<Contatos />} /> */}
      <Route path="/sobre-nos" element={<Contatos />} />
      <Route path="*" element={<PaginaNaoEncontrada />} />
    </Routes>
  );
}

export default App;
